<template>
  <div class="container-370 text-center">
    <div class="main-title mb-20 mt-40">
      <p>予約内容を選択肢から選んでください（必須）</p>
    </div>
    <el-select
      v-if="$auth.user().type === 0"
      class="select default h-44 w-370 black-placeholder"
      :value="value" placeholder="ランチョン"
      @change="handleChangeCategory"
    >
      <el-option
        class="black-placeholder"
        v-for="item in meetingCategories"
        v-if="item.type === 'reservation'"
        :key="item.id"
        :label="item.name_kanji"
        :value="item.id">
      </el-option>
    </el-select>

    <el-select
      v-else
      class="select default h-44 w-370 black-placeholder"
      :value="value" placeholder="ランチョン"
      @change="handleChangeCategory"
    >
      <el-option class="black-placeholder"
                 v-for="item in meetingCategories"
                 v-if="item.type === 'online'"
                 :key="item.id"
                 :label="item.name_kanji"
                 :value="item.id">
      </el-option>
    </el-select>

    <PPAccountSettingBox v-if="showSettingBox"/>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import PPAccountSettingBox from '@/components/PPAccountSetting'
import {USER_TYPE_PATIENT} from '@/const'

export default {
  props: {
    value: {type: Number, required: false}
  },
  components: {PPAccountSettingBox},
  computed: {
    ...mapGetters({
      meetingCategories: 'meetings/categories'
    }),
    showSettingBox: function () {
      return this.$auth.user().type === USER_TYPE_PATIENT
    }
  },
  data () {
    return {
      selectedCategory: null,
      categories: []
    }
  },
  methods: {
    handleChangeCategory (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/SelectCategory.vue